import { axiosApi } from "../../../../../api/dbAxios";

export const fetchDocLink = async (link: string) => {
  try {
    const response = await axiosApi.get(`/gen_link/?link=${link}`);
    return response.data.link;
  } catch (error) {
    console.error("Error updating document info:", error);
    return {};
  }
};
